import { object } from "yup";
import { nonEmptyString } from "@covertree/utils";

import {
  InjuredPeopleFormPart,
  injuredPeopleValidation,
} from "../shared/InjuredPersonsSection/form";

export interface OtherFormPart {
  claimDescription: string;
}
export type OtherForm = OtherFormPart & InjuredPeopleFormPart;

export const validation = object({
  claimDescription: nonEmptyString("Claim description").max(
    3000,
    "Claim description is too long"
  ),
  ...injuredPeopleValidation,
});
